import { afterEvent, cardRef, defineGameCard } from '../authoring/index.js';
import { ScrapCard } from './tokens.js';
function grow(ctx) {
    const self = ctx.self;
    if (self === undefined)
        return;
    ctx.ops.modifyStat(self.id, 'attack', 1, self.id);
    ctx.ops.modifyStat(self.id, 'maxHealth', 1, self.id);
    ctx.ops.modifyStat(self.id, 'health', 1, self.id);
}
export const TrashCritterCard = defineGameCard({
    id: 'trash_critter',
    gameplay: {
        type: 'UNIT', cost: 2,
        baseStats: { attack: 2, health: 2 },
    },
    presentation: {
        name: 'Мусорный зверёк',
        description: 'Каждый раз, когда ваш Хлам получает урон, Мусорный зверёк получает +1/+1.',
        glyph: {
            colors: ['#10213A', '#E1C382', '#4E5453', '#363C3F', '#8D7C5D'],
            rows: [
                '....111.....11..2...',
                '....1331...141..22..',
                '.....444333111.22...',
                '.....11333333.222...',
                '....13331551312.....',
                '.11.13334353312.....',
                '133114433324341.22..',
                '.13411144353344.2...',
                '..11133114111445....',
                '.1334333111115555...',
                '.13333333333352225..',
                '.143333414334122225.',
                '1144443143144152222.',
                '1344333143344452222.',
                '1344433334444452222.',
                '.143441334144152225.',
                '..1444444414111552..',
                '...143411111111435..',
                '....144....111......',
                '....111....141......',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('scrap'), cardRef('trash_critter')],
    abilities: [
        afterEvent({
            event: 'DamageDealt',
            run(ctx, event) {
                const self = ctx.self;
                if (self === undefined || event.target.kind !== 'unit' || event.amount <= 0)
                    return;
                if (event.targetDefId !== ScrapCard.id || event.targetControllerId !== self.controllerId)
                    return;
                grow(ctx);
            },
        }),
    ],
    ui: { mechanics: ['scrap'] },
});
//# sourceMappingURL=trash-critter.js.map